import React from 'react';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import Alert from '@roo/roo/Alert';
import pageJump from '@projects/Shell/utils/pageJump';
import { getStorage, removeStorage } from '@utils/localStorage';
import { RootState } from '../../store';
import styles from './MainContent.module.scss';

import { IQueryMenuItem } from '../../api/define';
import { getFrameByName, FRAME_NAME } from '../../utils/subFrames';

type MainContentProps = {
    isMenuFolded: boolean;
    iframeHash: string;
    pageHash: string;
    activeDemotionContext: string;
    leftMenuList: IQueryMenuItem[];
    setFrameHash: (val: string) => void;
    setShellHash: (val: string) => void;
    setPageHash: (val: string) => void;
};

const { useEffect } = React;

/** 主页面iframe */
const MainContent: React.FC<MainContentProps> = ({
    isMenuFolded,
    iframeHash,
    pageHash,
    activeDemotionContext,
    leftMenuList,
    setFrameHash,
    setPageHash,
    setShellHash,
}) => {
    useEffect(() => {
        const hash = window.location.hash ? window.location.hash.substr(1) : '';
        setShellHash(hash);
    }, []);

    // 外层页面跳转
    useEffect(() => {
        if (leftMenuList && leftMenuList.length) {
            // 更新外层页面url和iframe的url
            if (pageHash && pageHash !== '/') {
                setPageHash(pageHash);
                const thisWindow = pageJump.getThisWindow();
                thisWindow.location.hash = pageHash;
            } else {
                // 首次进入如果hash是空则跳转到左侧菜单的第一个页面
                let iframeUrl = '';
                const firstMenu = leftMenuList[0];
                iframeUrl = firstMenu.url;
                if (firstMenu.subMenus && firstMenu.subMenus.length) {
                    iframeUrl = firstMenu.subMenus[0].url;
                }
                setFrameHash(iframeUrl);
            }
        }
    }, [pageHash, leftMenuList && leftMenuList.length]);

    // iframe页面跳转
    useEffect(() => {
        const hashFrame = getFrameByName(FRAME_NAME.HASH);
        if (hashFrame && iframeHash !== '') {
            const noJump = getStorage('nojump');
            removeStorage('nojump');
            if (noJump !== 'true') {
                hashFrame.location.replace(iframeHash);
            }
        }
    }, [iframeHash]);

    return (
        <div className={`${styles.mainContainer} ${isMenuFolded ? styles.folded : ''}`}>
            {activeDemotionContext ? (
                <Alert
                    type="danger"
                    title={activeDemotionContext}
                    style={{ color: '#FF192D' }}
                    icon="warning"
                />
            ) : null}
            {/* 主页面iframe */}
            <iframe
                id="hashframe"
                title="mainContainer"
                src=""
                width="100%"
                className={activeDemotionContext ? styles.underDemotionBar : ''}
                frameBorder="no"
                name="hashframe"
                allow="fullscreen; clipboard-read *; clipboard-write *"
            />
        </div>
    );
};

const mapStateToProps = (state: RootState) => {
    return {
        isMenuFolded: state.shellLeftMenu.isMenuFolded,
        iframeHash: state.mainContent.iframeHash,
        pageHash: state.mainContent.pageHash,
        menuInfo: state.shellLeftMenu.menuInfo,
        leftMenuList: state.shellLeftMenu.leftMenuList,
        activeDemotionContext: state.shellCommon.activeDemotionContext,
    };
};

const mapDispatchToProps = (dispatch: Dispatch) => ({
    setMenuFold: (val: boolean) => {
        dispatch({ type: 'shellLeftMenu/setMenuFold', payload: val });
    },
    setFrameHash: (val: string) => {
        dispatch({ type: 'mainContent/setFrameHash', payload: val });
    },
    setPageHash: (val: string) => {
        dispatch({ type: 'mainContent/setPageHash', payload: val });
    },
    setShellHash: (val: string) => {
        dispatch({ type: 'mainContent/setShellHash', payload: val });
    },
});

export default connect(mapStateToProps, mapDispatchToProps)(MainContent);
